import { SourceStatus } from 'shared/types/source';
import { EnclaveType } from 'shared/types/enclave';
import { getSourceType } from 'shared/utils/source';

export const SEARCH_FILTER_NAME = 'searchFilter';
export const TYPE_FILTER_NAME = 'typeFilter';
export const STATUS_FILTER_NAME = 'statusFilter';
export const SOURCE_COUNT_LIMIT = 10;

export const TYPE_FILTER_OPTIONS = Object.values(EnclaveType).map((enclaveType) => ({
  name: enclaveType,
  label: getSourceType(enclaveType),
}));

export const STATUS_FILTER_OPTIONS = [
  { name: SourceStatus.ERROR },
  { name: SourceStatus.PENDING },
  { name: SourceStatus.UP },
];
